import React, { Fragment } from 'react';
import { Card } from './styles';
import { Button, Progress } from 'antd';
import { dateTimeConversion } from '../../utils/javascript';
import { FilesIcon, PrinterIcon } from '../../images/svgIcons';
import { withTranslation } from 'react-i18next';
import { BATCH_LIST } from './translationValues';

const NAMESPACES = ['BATCH_LIST'];

const BatchList = props => {
  const { batchList, setCreateBatch, setBatchData, getAllTagValues, t } = props;
  return (
    <>
      <Card height={'238px'} width={'294px'} padding={'24px'} className={'createBatchCard'}>
        <div>
          <Button
            onClick={() => {
              setCreateBatch(true);
            }}
          >
            +
          </Button>
          <h2 className="createBatchTitle">{t(BATCH_LIST.CREATE_NEW_PRINT_TITLE.key, BATCH_LIST.CREATE_NEW_PRINT_TITLE.value)}</h2>
          <p className="createBatchDescription">{t(BATCH_LIST.CREATE_BATCH_DESCRIPTION.key, BATCH_LIST.CREATE_BATCH_DESCRIPTION.value)}</p>
        </div>
        <div className="createCard">
          <Button
            onClick={() => {
              setCreateBatch(true);
            }}
          >
            {t(BATCH_LIST.CREATE_NEW_BUTTON.key, BATCH_LIST.CREATE_NEW_BUTTON.value)}
          </Button>
        </div>
      </Card>
      {batchList?.map((li, key) => {
        return (
          <Card
            key={key}
            className={'batchCard'}
            height={'238px'}
            width={'294px'}
            status={li.inqueueCount > 0 ? 'active' : li.failedCount > 0 ? 'exception' : 'success'}
            animation={true}
            animationDelay={key < 10 ? key * 200 + 'ms' : ''}
          >
            <Progress
              percent={100}
              status={li.inqueueCount > 0 ? 'active' : li.failedCount > 0 ? 'exception' : 'success'}
              showInfo={false}
            />
            <p className="createdOn">{dateTimeConversion(li.createdOn, true, true, false)}</p>
            <h2 className="batchTitle" onClick={() => setBatchData(li)}>
              {li.name}
            </h2>
            <p className="batchDescription">{li.description || '-'}</p>
            <div className="batchDetails">
              <div>
                {FilesIcon()}
                <p>{t(BATCH_LIST.FILES_LABEL.key, BATCH_LIST.FILES_LABEL.value)}:</p>
                <p>{li.failedCount + li.successCount + li.inqueueCount}</p>
              </div>
              <div>
                {PrinterIcon()}
                <p>{t(BATCH_LIST.PRINTER_LABEL.key, BATCH_LIST.PRINTER_LABEL.value)}:</p>
                <p>{li.printerName}</p>
              </div>
            </div>
            <div className="batchStats">
              <div>
                <h2>{li.successCount}</h2>
                <p> {t(BATCH_LIST.PRINTED_LABEL.key, BATCH_LIST.PRINTED_LABEL.value)}</p>
              </div>
              <div>
                <h2>{li.inqueueCount}</h2>
                <p>{t(BATCH_LIST.QUEUE_LABEL.key, BATCH_LIST.QUEUE_LABEL.value)}</p>
              </div>
              <div>
                <h2>{li.failedCount}</h2>
                <p>{t(BATCH_LIST.FAILED_LABEL.key, BATCH_LIST.FAILED_LABEL.value)}</p>
              </div>
            </div>
            <button className="appliedFilterButton">
              {(li.nameSearched ||
                li.dateFrom ||
                li.dateTo ||
                li.tag1 ||
                li.tag2 ||
                li.tag3 ||
                li.tag4 || li.documentPages) && <span>{t(BATCH_LIST.APPLIED_FILTER_BUTTON.key, BATCH_LIST.APPLIED_FILTER_BUTTON.value)}</span>}
            </button>
            <div className="appliedFilters">
              <table>
                <tbody>
                  <tr>
                    <th colSpan={2}>{t(BATCH_LIST.APPLIED_FILTER_TABLE_HEADER.key, BATCH_LIST.APPLIED_FILTER_TABLE_HEADER.value)}:</th>
                  </tr>
                  {li.nameSearched && (
                    <tr>
                      <td>{t(BATCH_LIST.APPLIED_FILTER_SEARCH_LABEL.key, BATCH_LIST.APPLIED_FILTER_SEARCH_LABEL.value)}:</td>
                      <td>{li.nameSearched}</td>
                    </tr>
                  )}
                  {li.dateFrom && li.dateTo && (
                    <tr>
                      <td>{t(BATCH_LIST.APPLIED_FILTER_DATE_RANGE_LABEL.key, BATCH_LIST.APPLIED_FILTER_DATE_RANGE_LABEL.value)}:</td>
                      <td>
                        {dateTimeConversion(li.dateFrom, true, true, false)} - {t(BATCH_LIST.APPLIED_FILTER_DATE_TO.key, BATCH_LIST.APPLIED_FILTER_DATE_TO.value)} -
                        {dateTimeConversion(li.dateTo, true, true, false)}
                      </td>
                    </tr>
                  )}
                  {(li.tag1 || li.tag2 || li.tag3 || li.tag4) && (
                    <tr>
                      <td>{t(BATCH_LIST.APPLIED_FILTER_TAGS_LABEL.key, BATCH_LIST.APPLIED_FILTER_TAGS_LABEL.value)}:</td>
                      <td className="tagsList">
                        {getAllTagValues(li)?.map((tagVal, key) => {
                          return (
                            <Fragment key={key}>
                              {key < 3 && (
                                <p className="tags" key={key}>
                                  {tagVal}
                                </p>
                              )}
                            </Fragment>
                          );
                        })}
                        {getAllTagValues(li)?.length > 3 && (
                          <p className="moreTags">{`+ ${getAllTagValues(li)?.length - 3}`}</p>
                        )}
                      </td>
                    </tr>
                  )}
                  {li.documentPages && (
                    <tr>
                      <td>Pages:</td>
                      <td>{li.documentPages}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Card>
        );
      })}
    </>
  );
};
export default withTranslation(NAMESPACES)(BatchList);
